/**
 * OptimizationPage - AI-powered optimization recommendations
 *
 * Surfaces the OptimizationDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides AI-generated recommendations for workflow, resource, and process optimization.
 *
 * Route: /admin/optimization
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconBulb } from '@tabler/icons-react';

import { OptimizationDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function OptimizationPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="yellow">
            <IconBulb size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Optimization Recommendations</Title>
            <Text size="sm" c="dimmed">
              AI-powered suggestions for workflow and resource optimization
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <OptimizationDashboard />
    </Container>
  );
}

export default OptimizationPage;
